import { get, post, deleteApi } from "../../api/index";
import { API_ENDPOINTS } from "../../constants";

const { APIS } = API_ENDPOINTS;

// ------- Google sheet related services -------

export const authGoogleSheetService = () =>
  new Promise((resolve, reject) => {
    post(`${APIS.GOOGLE_SHEET_AUTH}code`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.error(
          `authGoogleSheetService => authGoogleSheetService => ${error}`,
        );
        reject(error);
      });
  });

export const authGoogleSheetTokenUpdateService = code =>
  new Promise((resolve, reject) => {
    post(`${APIS.GOOGLE_SHEET_AUTH}token?code=${encodeURIComponent(code)}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.error(
          `authGoogleSheetTokenUpdateService => authGoogleSheetTokenUpdateService => ${error}`,
        );
        reject(error);
      });
  });

export const fetchGoogleSheet = () =>
  new Promise((resolve, reject) => {
    get(`${APIS.GOOGLE_SHEET_DATA}sheets`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.error(`fetchGoogleSheet => fetchGoogleSheet => ${error}`);
        reject(error);
      });
  });

export const fetchGoogleSheetById = id =>
  new Promise((resolve, reject) => {
    get(`${APIS.GOOGLE_SHEET_DATA}sheets/${id}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.error(
          `fetchGoogleSheetById => fetchGoogleSheetById => ${error}`,
        );
        reject(error);
      });
  });

export const fetchGoogleWorkSheetService = (id, name, resync, dataRange) =>
  new Promise((resolve, reject) => {
    get(
      `${APIS.GOOGLE_SHEET_DATA}sheets/${id}/data?workbook=${name}${dataRange ||
        ""}${resync || ""}`,
    )
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.error(
          `fetchGoogleWorkSheetByName => fetchGoogleWorkSheetByName => ${error}`,
        );
        reject(error);
      });
  });

export const unLinkGoogleSheetAccount = () =>
  new Promise((resolve, reject) => {
    deleteApi(`${APIS.GOOGLE_SHEET_AUTH}token`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.error(
          `unLinkGoogleSheetAccount => unLinkGoogleSheetAccount => ${error}`,
        );
        reject(error);
      });
  });

export const fetchGoogleUserInfo = () =>
  new Promise((resolve, reject) => {
    get(`${APIS.GOOGLE_SHEET_DATA}user_info`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.error(`fetchGoogleUserInfo => fetchGoogleUserInfo => ${error}`);
        reject(error);
      });
  });



// WEBPACK FOOTER //
// ./src/actions/GoogleSheetActions/googleSheetServices.js